<template>
  <w-schema :model="model">
    <v-text-field :name="name" :label="label" :type="type" v-bind="$attrs" v-on="$listeners" />
  </w-schema>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';

// @vuese
// Komponent prostego inputa
// @group forms
export default {
  components: { WSchema },
  props: {
    // JSchema
    model: {
      type: Object,
      required: true
    },
    // Tytuł jeżeli ma nadpisać tytuł z schemy
    title: {
      type: String,
      required: false
    },
    // name
    name: {
      type: String,
      required: false
    },
    // Typ inputa
    type: { type: String, default: 'text' }
  },
  computed: {
    label() {
      if (this.title) {
        return this.title;
      }
      return `${this.model.$schema.title} ${this.model.$schema.fieldRequired ? '*' : ''}`;
    }
  }
};
</script>
